export default __webpack_public_path__ + "static/char-s-13-jp-02dfc98d40b59baa566ddd418f240ca1.png";